import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBlurBackgroundConfig } from '@/data/landingConfig/landingBlurBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BlurBackground } from './schemaObject';

interface Props {}
const BlurBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BlurBackground} />
			<LandingTemplate
				data={landingBlurBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAIBackground()}
			/>
		</>
	);
};

export default BlurBackground;
